import { render, staticRenderFns } from "./CapacityOptimizerPanel.vue?vue&type=template&id=0a3d348e&scoped=true"
import script from "./CapacityOptimizerPanel.vue?vue&type=script&lang=js"
export * from "./CapacityOptimizerPanel.vue?vue&type=script&lang=js"
import style0 from "./CapacityOptimizerPanel.vue?vue&type=style&index=0&id=0a3d348e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d348e",
  null
  
)

export default component.exports